import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LieferungenLeistung: React.FC = () => {
  useEffect(() => {
    // Add meta robots tag to prevent indexing
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    document.head.appendChild(metaRobots);

    // Clean up function to remove the meta tag when component unmounts
    return () => {
      const existingTag = document.querySelector('meta[name="robots"]');
      if (existingTag) {
        document.head.removeChild(existingTag);
      }
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8 max-w-4xl">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h1 className="text-2xl font-bold text-deep-blue mb-6">Lieferung & Leistung</h1>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">Was wir liefern</h2>
            <p className="mb-4">
              AdressFinder.org erbringt eine <strong>digitale Dienstleistung</strong>: die Ermittlung der aktuellen Meldeanschrift einer Person in Deutschland. Es erfolgt <strong>keine physische Warenlieferung</strong>.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">Bereitstellung / Liefermethode</h2>
            <p className="mb-4">
              Die Ergebnisse werden <strong>digital</strong> bereitgestellt – per E-Mail an die von Ihnen angegebene Adresse und/oder in Ihrem Benutzerkonto (sofern vorhanden).
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">Leistungsablauf & Zeitrahmen</h2>
            <ul className="list-disc pl-6 space-y-3">
              <li>
                <strong>Sofortauskunft (falls verfügbar):</strong> Ergebnis in der Regel <strong>sofort bis binnen weniger Minuten</strong>.
              </li>
              <li>
                <strong>Anfrage beim zuständigen Melderegister:</strong> Wir leiten Ihren Auftrag <strong>in der Regel binnen 24 Stunden (Werktage)</strong> an das zuständige Amt weiter.
              </li>
              <li>
                <strong>Bearbeitungszeit der Ämter:</strong> Erfahrungswert <strong>1–14 Werktage</strong>, vereinzelt <strong>bis zu 4 Wochen</strong> (abhängig vom Amt und dessen Auslastung).
              </li>
              <li>
                <strong>Benachrichtigung:</strong> Wir informieren per E-Mail, sobald ein Ergebnis vorliegt oder Rückfragen bestehen.
              </li>
            </ul>
          </section>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">Leistungsgebiet</h2>
            <p className="mb-4">
              Die Adressrecherche bezieht sich <strong>ausschließlich auf Personen mit Wohnsitz in Deutschland</strong>. Bestellungen sind <strong>weltweit</strong> möglich.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">Kosten / Versandkosten</h2>
            <p className="mb-4">
              Es fallen <strong>keine Versandkosten</strong> an. Es gelten die auf der Website ausgewiesenen <strong>Servicepreise</strong>; <strong>keine versteckten Gebühren</strong>.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-deep-blue mb-4">Kontakt</h2>
            <p className="mb-4">
              YN Digital GmbH, Am Schulhof 23, 28865 Lilienthal, Deutschland<br />
              E-Mail: <a href="mailto:info@adressfinder.org" className="text-blue-600 hover:underline">info@adressfinder.org</a>
            </p>
          </section>
          
          <div className="mt-8">
            <Link to="/" className="text-blue-600 hover:underline">Zurück zur Startseite</Link>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default LieferungenLeistung;
